import { render, staticRenderFns } from "./workbook_mkediter.vue?vue&type=template&id=8f643b14&scoped=true&"
import script from "./workbook_mkediter.vue?vue&type=script&lang=js&"
export * from "./workbook_mkediter.vue?vue&type=script&lang=js&"
import style0 from "./workbook_mkediter.vue?vue&type=style&index=0&id=8f643b14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f643b14",
  null
  
)

export default component.exports